export default __webpack_public_path__ + "static/media/category.73955482.svg";